import { render, staticRenderFns } from "./site.vue?vue&type=template&id=4faa680a&"
import script from "./site.vue?vue&type=script&lang=ts&"
export * from "./site.vue?vue&type=script&lang=ts&"
import style0 from "./site.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/компетенции.амур-иро.рф/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4faa680a', component.options)
    } else {
      api.reload('4faa680a', component.options)
    }
    module.hot.accept("./site.vue?vue&type=template&id=4faa680a&", function () {
      api.rerender('4faa680a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/section/site.vue"
export default component.exports